<template>
  <div class="">
    <button
      type="button"
      class="
          uk-button
          uk-button-primary
          uk-display-block
          uk-width-1-1
      "
      :class="{active: isActive}"
      @click="click"
    >
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  name: 'TypeButton.vue',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    type: String,
  },
  data() {
    return {
      typeKey: this.type,
      isActive: this.active,
      title: this.$slots.default[0].text,
    };
  },
  methods: {
    click() {
      this.isActive = !this.isActive;
      this.$emit('click', this);
    },
  },
  watch: {
    active(to) {
      this.isActive = to;
    },
  },
};
</script>
